import { graphql } from "../gql";

export const updateFileMutationDoc = graphql(`
  mutation updateFile($id: ID!, $input: UpdateFileInput!) {
    updateFile(id: $id, input: $input) {
      ...FileFragment
    }
  }
`);
